module.exports = __webpack_public_path__ + "media/img/help_center/Student_Institution_Directory_02-1d15b96707522fc89d1b316e08bb5297.jpg";